export default {
  playerfacts: require("./playerfacts_0001.json"),
  playerstats: require("./playerstats_0002.json"),
  playercompare: require("./playercompare_0004.json"),
  teamcompare: require("./teamcompare_0005.json"),
  teamfacts: require("./teamfacts_0003.json"),
};
